<template>
  <div class="danger-rose">
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="25 15 250 165" xml:space="preserve">
      <defs>
       <filter id="shadow">
          <feDropShadow dx="2" dy="2" stdDeviation="3" flood-color="#000" flood-opacity=".75"/>
        </filter>
      </defs>
      <g style="fill:#fff;">
        <polygon stroke="#3a3a3a" :fill="low.nw | roseFillColor" points="78.48,51.709 58.01,55.381 54.33,75.846 69.562,83.466 69.655,83.315 72.167,69.347 86.05,66.857 "/>
        <polygon stroke="#3a3a3a" :fill="low.w | roseFillColor" points="59.55,99.793 69.562,83.466 54.33,75.846 39.523,99.988 54.32,124.132 69.682,116.455 69.649,116.272 "/>
        <polygon stroke="#3a3a3a" :fill="low.sw | roseFillColor" points="69.682,116.455 54.32,124.132 57.992,144.602 77.726,148.149 85.602,132.662 72.155,130.244 "/>
        <polygon stroke="#3a3a3a" :fill="low.s | roseFillColor" points="86.124,132.756 85.602,132.662 77.726,148.149 78.457,148.281 102.599,163.089 126.743,148.291 119.007,132.809 102.602,142.863 "/>
        <polygon stroke="#3a3a3a" :fill="low.se | roseFillColor" points="135.532,116.47 133.053,130.257 119.081,132.763 119.007,132.809 126.743,148.291 147.213,144.619 150.893,124.154 "/>
        <polygon stroke="#3a3a3a" :fill="low.e | roseFillColor" points="165.7,100.013 150.902,75.869 135.664,83.483 145.672,99.811 135.564,116.288 135.532,116.47 150.893,124.154 "/>
        <polygon stroke="#3a3a3a" :fill="low.ne | roseFillColor" points="147.23,55.398 126.766,51.719 119.078,66.836 119.097,66.847 133.065,69.359 135.571,83.331 135.664,83.483 150.902,75.869 "/>
        <polygon stroke="#3a3a3a" :fill="low.n | roseFillColor" points="102.619,56.741 119.078,66.836 126.766,51.719 102.624,36.912 78.48,51.709 86.05,66.857 86.14,66.841 "/>
      </g>
      <g style="fill:#fff; filter:url(#shadow);">
        <polygon stroke="#3a3a3a" :fill="mid.nw | roseFillColor" points="85.112,82.386 93.095,80.955 86.05,66.857 72.167,69.347 69.655,83.315 69.562,83.466 83.605,90.492 83.677,90.375 "/>
        <polygon stroke="#3a3a3a" :fill="mid.w | roseFillColor" points="77.897,99.798 83.605,90.492 69.562,83.466 59.55,99.793 69.649,116.272 69.682,116.455 83.712,109.444 83.673,109.223 "/>
        <polygon stroke="#3a3a3a" :fill="mid.sw | roseFillColor" points="83.712,109.444 69.682,116.455 72.155,130.244 85.602,132.662 92.759,118.588 85.106,117.213 "/>
        <polygon stroke="#3a3a3a" :fill="mid.s | roseFillColor" points="93.095,118.648 92.759,118.588 85.602,132.662 86.124,132.756 102.602,142.863 119.007,132.809 111.935,118.656 102.518,124.428 "/>
        <polygon stroke="#3a3a3a" :fill="mid.se | roseFillColor" points="121.343,109.371 119.932,117.219 111.941,118.652 111.935,118.656 119.007,132.809 119.081,132.763 133.053,130.257 135.532,116.47 "/>
        <polygon stroke="#3a3a3a" :fill="mid.e | roseFillColor" points="135.664,83.483 121.485,90.568 127.148,99.808 121.368,109.23 121.343,109.371 135.532,116.47 135.564,116.288 145.672,99.811 "/>
        <polygon stroke="#3a3a3a" :fill="mid.ne | roseFillColor" points="119.938,82.393 121.372,90.383 121.485,90.568 135.664,83.483 135.571,83.331 133.065,69.359 119.097,66.847 119.078,66.836 111.91,80.932 111.95,80.957 "/>
        <polygon stroke="#3a3a3a" :fill="mid.n | roseFillColor" points="102.527,75.177 111.91,80.932 119.078,66.836 102.619,56.741 86.14,66.841 86.05,66.857 93.095,80.955 93.103,80.953 "/>
      </g>
      <g style="fill:#fff; filter:url(#shadow);">
        <polygon stroke="#3a3a3a" :fill="high.nw | roseFillColor" points="102.414,99.604 93.095,80.955 85.112,82.386 83.677,90.375 83.605,90.492 102.293,99.841 "/>
        <polygon stroke="#3a3a3a" :fill="high.w | roseFillColor" points="102.293,99.841 83.605,90.492 77.897,99.798 83.673,109.223 83.712,109.444 102.076,100.268 "/>
        <polygon stroke="#3a3a3a" :fill="high.sw | roseFillColor" points="83.712,109.444 85.106,117.213 92.759,118.588 102.076,100.268 "/>
        <polygon stroke="#3a3a3a" :fill="high.s | roseFillColor" points="102.611,100 102.076,100.268 92.759,118.588 93.095,118.648 102.518,124.428 111.935,118.656 102.612,100.001 "/>
        <polygon stroke="#3a3a3a" :fill="high.se | roseFillColor" points="119.932,117.219 121.343,109.371 102.612,100.001 111.935,118.656 111.941,118.652 "/>
        <polygon stroke="#3a3a3a" :fill="high.e | roseFillColor" points="127.148,99.808 121.485,90.568 102.612,100 102.612,100.001 121.343,109.371 121.368,109.23 "/>
        <polygon stroke="#3a3a3a" :fill="high.ne | roseFillColor" points="102.612,100 121.485,90.568 121.372,90.383 119.938,82.393 111.95,80.957 111.91,80.932 102.414,99.604 "/>
        <polygon stroke="#3a3a3a" :fill="high.n | roseFillColor" points="111.91,80.932 102.527,75.177 93.103,80.953 93.095,80.955 102.414,99.604 "/>
      </g>
      <g>
        <text transform="matrix(1 0 0 1 97.75 29.7798)" font-size="12" font-weight="bold">N</text>
        <text transform="matrix(1 0 0 1 99.5801 174.9004)" font-size="10">S</text>
        <text transform="matrix(1 0 0 1 170.5957 104.582)" font-size="10">E</text>
        <text transform="matrix(1 0 0 1 150.4736 51.3208)" font-size="7">NE</text>
        <text transform="matrix(1 0 0 1 151.1943 152.7061)" font-size="7">SE</text>
        <text transform="matrix(1 0 0 1 44.459 51.3208)" font-size="7">NW</text>
        <text transform="matrix(1 0 0 1 45.1797 152.7061)" font-size="7">SW</text>
        <text transform="matrix(1 0 0 1 25.6279 104.582)" font-size="10">W</text>
        <text transform="matrix(1 0 0 1 202.1719 115.8027)" fill="#808285" font-size="7">High Alpine</text>
        <text transform="matrix(1 0 0 1 202.1719 127.8828)" fill="#808285" font-size="7">Alpine</text>
        <text transform="matrix(1 0 0 1 202.1719 139.4551)" fill="#808285" font-size="7">Sub Alpine</text>
        <line fill="none" stroke="#3d3d3d" stroke-width="0.25" x1="198.5" y1="114.132" x2="113.881" y2="114.132"/>
        <line fill="none" stroke="#3d3d3d" stroke-width="0.25" x1="198.5" y1="126.5" x2="125.211" y2="126.5"/>
        <line fill="none" stroke="#3d3d3d" stroke-width="0.25" x1="198.5" y1="137.062" x2="135.62" y2="137.062"/>
      </g>
      <polygon fill="none" stroke="#3a3a3a" stroke-width="2" stroke-miterlimit="10" points="147.224,144.223 126.754,147.895 102.609,162.692 78.468,147.885 58.003,144.205 54.331,123.735 39.534,99.591 54.341,75.449 58.021,54.984 78.491,51.312 102.635,36.515 126.776,51.322 147.241,55.002 150.913,75.472 165.711,99.616 150.903,123.758 "/>
    </svg>
  </div>
</template>

<script>
  import colorSvgMixin from '../../mixins/color-svg';

  export default {
    mixins: [
      colorSvgMixin,
    ],

    props: {
      high: {
        type: Object,
        default() {
          return {};
        },
      },
      mid: {
        type: Object,
        default() {
          return {};
        },
      },
      low: {
        type: Object,
        default() {
          return {};
        },
      },
    },

    mounted() {
      const is_iPad = navigator.userAgent.match(/iPad/i) != null;

      if (is_iPad) {
        const groups = document.getElementsByTagName('g')

        for (var i=0; i < groups.length; i++) {
          groups[i].removeAttribute('style');
        }
      }
    },
  };
</script>
